import { Checkbox, CityState, DataSource, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSeating extends Layout {
    checkboxTerminalLocations: Checkbox;
    citystateSeatedLocation: CityState;
    labelEquipmentProgress: Label;
    labelErrorText: Label;
    locationSeatedLocation: Location;
    panelDrivers: Panel;
    panelError: Panel;
    panelLocation: Panel;
    panelSeatingInput: Panel;
    panelTrailers: Panel;
    sourceSeating: DataSource;
    sourceSeatingContinuityCheck: DataSource;
    switchLocationType: Switch;
    textboxDriverSeated: Textbox;
    textboxDriverTwo: Textbox;
    textboxSeatedDateTime: Textbox;
    textboxTractor: Textbox;
    textboxTrailer2: Textbox;
    textboxTrailer3: Textbox;
    textboxTrailer: Textbox;
}
